/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Link_ZaloInputs */

const vi_shop_home_link_zalo = /** @type {(inputs: Shop_Home_Link_ZaloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zalo`)
};

/**

* @param {Shop_Home_Link_ZaloInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_link_zalo = /** @type {((inputs?: Shop_Home_Link_ZaloInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Link_ZaloInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_link_zalo(inputs)
});